import { render, staticRenderFns } from "./Doughnutchart.vue?vue&type=template&id=7330fcf1&"
import script from "./Doughnutchart.vue?vue&type=script&lang=js&"
export * from "./Doughnutchart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports